<template>
    <div v-if="isLoading" class="loader-container">
        <div class="loader">
            <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ScreenLoader',
    props: ['isLoading'],
    components: {},
    data () {
        return {

        }
    }
}
</script>

<style lang="less" scoped>
    .loader-container {
        z-index: 10;
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.21);

        .loader {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            h1 {
                font-weight: 600;
            }
        }
    }
</style>
